import { Form } from 'antd';
import { useState } from 'react';
import AccountCard from 'src/app/components/AccountCard/AccountCard';
import AccountForm from 'src/app/forms/AccountForm/AccountForm';
import { useAppSelector } from 'src/app/redux/hook';
import AddInteractionIcon from 'src/icons/AddInteractionIcon';
import { Account } from 'src/types/account.type';

interface IAccountListProps {
  accounts: Account[];
  setAccounts: React.Dispatch<React.SetStateAction<Account[]>>;
}

const AccountList: React.FC<IAccountListProps> = ({ accounts, setAccounts }) => {
  //   const [accounts, setAccounts] = useState<{ accountName: string; accountNo: string }[]>([]);
  const [showAddAccountCard, setShowAddAccountCard] = useState<boolean>(false);
  const [accountForm] = Form.useForm();
  const { theme } = useAppSelector((state) => state.configContent);

  const onAccountFormFinish = (values: any) => {
    setShowAddAccountCard(false);
    setAccounts((prev) => [...prev, values]);
    accountForm.resetFields();
  };

  const onDeleteAccount = (accNo: string) => {
    setAccounts((prev) => prev.filter((acc) => acc.accountNo !== accNo));
  };

  return (
    <>
      {!showAddAccountCard && (
        <>
          <div style={{ marginLeft: 'auto', width: 'fit-content' }}>
            <AddInteractionIcon onClick={() => setShowAddAccountCard(true)} />
          </div>
          {!accounts.length && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
              {/* <NoDataIcon style={{ height: '150px' }} color={theme.colors.quoteBgc} /> */}
              No accounts added
            </div>
          )}
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', paddingInline: '1rem', paddingBottom: '1rem' }}>
            {accounts.map((acc) => {
              return (
                <AccountCard
                  key={acc.accountNo}
                  title={acc.accountName}
                  onRemove={() => onDeleteAccount(acc.accountNo)}
                >
                  <>
                    <div style={{ fontSize: '11px' }}> Account No:</div>
                    <div style={{ fontSize: '13px', fontWeight: 'bold' }}>{acc.accountNo}</div>
                  </>
                </AccountCard>
              );
            })}
          </div>
        </>
      )}

      {showAddAccountCard && (
        <div style={{ padding: '1rem' }}>
          <AccountCard title="Add Account" onRemove={() => setShowAddAccountCard(false)} style={{ width: '100%' }}>
            <AccountForm form={accountForm} onFinish={onAccountFormFinish} />
          </AccountCard>
        </div>
      )}
    </>
  );
};

export default AccountList;
